import { defineRouting } from 'next-intl/routing';

export const locales = ['he', 'en'] as const;
export type Locale = (typeof locales)[number];

export const routing = defineRouting({
  locales,
  defaultLocale: 'he',
  localePrefix: 'as-needed',
  /*
   * The proxy decides the language for URLs that do not name one — by country, not by browser
   * language (docs/00-decisions.md). next-intl's own cookie + Accept-Language detection is off so
   * it cannot pre-empt that; it still records the locale of every full page load in NEXT_LOCALE,
   * which is what makes a language stick to a device.
   */
  localeDetection: false,
  localeCookie: { maxAge: 60 * 60 * 24 * 365 },
});

export const dirOf = (locale: string) => (locale === 'he' ? 'rtl' : 'ltr');
